import { type IApiResponse, type IUserState, type IUserStates } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

export const userApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getUser: builder.query<IUserStates, IGetQuery>({
			query: ({ paged, query }) => `/User${getCommandQuery(paged, ...(query || []))}`,
		}),
		getUserById: builder.query<IUserStates, { id: string }>({
			query: ({ id }) => ({
				url: '/User',
				params: { id },
			}),
		}),
		getUserByEmail: builder.mutation<IApiResponse<IUserState>, { email: string }>({
			query: (data) => ({
				method: 'POST',
				url: '/User/GetUserByEmail',
				body: data,
			}),
		}),
		getUserByPhoneNumber: builder.mutation<IApiResponse<IUserState>, { phoneNumber: string }>({
			query: (data) => ({
				method: 'POST',
				url: '/User/GetUserByPhoneNumber',
				body: data,
			}),
		}),
		getUserRoles: builder.query<IApiResponse<string[]>, { email: string }>({
			query: ({ email }) => ({
				method: 'GET',
				url: '/User/GetUserRoles',
				params: { email },
			}),
		}),
		deleteUser: builder.mutation<IApiResponse, { email: string }>({
			query: ({ email }) => ({
				method: 'DELETE',
				url: `/User/Delete?email=${email}`,
			}),
		}),
		addUserToRole: builder.mutation<IApiResponse, { userId: string; roleName: string[] }>({
			query: ({ userId, roleName }) => ({
				method: 'POST',
				url: `/User/AddUserToRole/${userId}`,
				body: { roleName },
			}),
		}),
		removeUserFromRole: builder.mutation<IApiResponse, { userId: string; roleName: string[] }>({
			query: ({ userId, roleName }) => ({
				method: 'POST',
				url: `/User/RemoveUserFromRole/${userId}`,
				body: { roleName },
			}),
		}),
		activateUser: builder.mutation<IApiResponse, { userId: string }>({
			query: (data) => ({
				method: 'POST',
				url: '/User/activate',
				body: data,
			}),
		}),
		deactivateUser: builder.mutation<IApiResponse, { userId: string }>({
			query: (data) => ({
				method: 'POST',
				url: '/User/deactivate',
				body: data,
			}),
		}),
	}),
});

export const {
	useGetUserQuery,
	useLazyGetUserQuery,
	useGetUserByIdQuery,
	useLazyGetUserByIdQuery,
	useGetUserByEmailMutation,
	useGetUserByPhoneNumberMutation,
	useGetUserRolesQuery,
	useLazyGetUserRolesQuery,
	useDeleteUserMutation,
	useAddUserToRoleMutation,
	useRemoveUserFromRoleMutation,
	useActivateUserMutation,
	useDeactivateUserMutation,
} = userApiSlice;
